import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileDrawer } from './MobileDrawer';
import { useViewMode } from '../../context/ViewModeContext';
import { CommandCenter } from '../command/CommandCenter';
import { useApplyTheme } from '../../hooks/useTheme';
import { TaskDateShiftPrompt } from '../tasks/TaskDateShiftPrompt';
import { startBrowserLogging } from '../../utils/browserLogging';

export function AppLayout() {
  const { isMobile } = useViewMode();
  const [collapsed, setCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Dark mode belongs to the app shell: public and guest pages never mount it.
  useApplyTheme();
  // So does sending its crashes to the Logs screen: only the signed-in app
  // has somebody to file them under.
  useEffect(() => startBrowserLogging(), []);

  // Close mobile drawer when switching to desktop mode
  useEffect(() => {
    if (!isMobile) setSidebarOpen(false);
  }, [isMobile]);

  return (
    <CommandCenter>
      <div className="flex h-screen overflow-hidden">
        {/* Desktop sidebar */}
        {!isMobile && <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />}

        {/* Mobile sidebar drawer */}
        {isMobile && (
          <MobileDrawer open={sidebarOpen} onClose={() => setSidebarOpen(false)}>
            <Sidebar collapsed={false} onToggle={() => setSidebarOpen(false)} mobile />
          </MobileDrawer>
        )}

        <div className="flex flex-col flex-1 overflow-hidden">
          <Header isMobile={isMobile} onMenuClick={() => setSidebarOpen(true)} />
          <main className={`flex-1 overflow-auto bg-gray-50 ${isMobile ? 'p-3' : 'p-6'}`}>
            <Outlet />
          </main>
        </div>
      </div>
      {/* An event's date moved: offer to move the tasks that follow it. */}
      <TaskDateShiftPrompt />
    </CommandCenter>
  );
}
